var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fixed p-12 bg-white rounded-lg"},[_c('span',{staticClass:"absolute close cursor-pointer",on:{"click":function($event){return _vm.$emit('close')}}},[_c('FontAwesomeIcon',{attrs:{"icon":"times-circle"}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }